import { useDispatch } from 'react-redux';
import { WorkspaceType } from 'state/workspaces/model';
import { workspaceTabMoved } from 'state/workspaces/workspace.actions';

export type TabPersistenceOptions = {
  workspace: WorkspaceType;
};

export const useTabPersistence = ({ workspace }: TabPersistenceOptions) => {
  const dispatch = useDispatch();

  const moveTab = (sourceIndex: number, targetIndex: number) => {
    if (sourceIndex === targetIndex) {
      return;
    }
    dispatch(workspaceTabMoved(workspace, sourceIndex, targetIndex));
  };

  return {
    moveTab,
  };
};
